import axiosIns from "@/api/axios";

export const GET_LIST_IDP_LEARNING = (query) => {
  let url = "/idp/learnings";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const SUBMIT_IDP_LEARNING = (query, data) => {
  let url = "/idp/submit";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.post(url, data);
};

export const GET_DETAIL_STRUCTURED_LEARNING = (payload) => {
  const { id, query } = payload;

  let url = `/idp/structured-learnings/detail/${id}`;

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_SUMMARY_IDP_LEARNING = (query) => {
  let url = "/tna/summary";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_SUMMARY_IDP_SOCIAL_LEARNING = (query) => {
  let url = "/idp/summary";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_SUMMARY_IDP_EXPERIENTIAL_LEARNING = (query) => {
  let url = "/idp/summary";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_IDP_PERIOD = (args) => {
  return axiosIns.get(`/idp-period`, args);
};

export const GET_SUBORDINATES = (query) => {
  const params = new URLSearchParams({ all: query?.all ?? true, ...(query || {}) }).toString();

  return axiosIns.get(`/users/subordinates?${params}`);
};

export const APPROVE_IDP_LEARNING = (query, data) => {
  let url = "/idp/approve";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.post(url, data);
};

export const ADD_SOCIAL_LEARNING = (data) => {
  let url = "/idp/social-learnings/add";

  return axiosIns.post(url, data);
};

export const CREATE_PROJECT_ACTIVITY = (data) => {
  let url = "/idp/experiential-learnings/project-activities";

  return axiosIns.post(url, data);
};

export const UPDATE_PROJECT_ACTIVITY = (payload) => {
  const { id, data } = payload;

  let url = `/idp/experiential-learnings/project-activities/${id}`;

  return axiosIns.put(url, data);
};

export const DELETE_PROJECT_ACTIVITY = (id) => {
  let url = `/idp/experiential-learnings/project-activities/${id}`;

  return axiosIns.delete(url);
};

export const ACTION_PROJECT = (data) => {
  let url = `/idp/experiential-learnings/action`;

  return axiosIns.post(url, data);
};

export const GET_LIST_EMPLOYEE = () => {
  let url = `/master-data/employee`;

  return axiosIns.get(url);
};

export const ADD_PROJECT_EXPERIENTIAL_LEARNING = (data) => {
  let url = `/idp/experiential-learnings/add`;

  return axiosIns.post(url, data, { headers: { "Content-Type": "multipart/form-data" } });
};
